import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const SnackbarToast = ({ open, handleClose }) => {
  return (
    <Snackbar
      open={open.open}
      onClose={handleClose}
      autoHideDuration={4000}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
    >
      <Alert
        severity={open.type === "success" ? "success" : "error"}
        variant="filled"
        sx={{ width: "100%" }}
        onClose={handleClose}
      >
        {open.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarToast;
